import { SelectionAllIcon as PhosphorSelectionAllIcon } from "@phosphor-icons/react/dist/ssr/SelectionAll";

import { createAppIcon } from "@/components/createAppIcon";

export const SelectAllIcon = /* @__PURE__ */ createAppIcon(PhosphorSelectionAllIcon);
